export enum EMemberType {
    Primary = 1,
    Partner = 2,
    Dependant = 3
}
